import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import SharedBannerMessage from 'ember-simplepractice/components/shared/banner-message';
import styles from './pending-insurance-info-banner.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
export default class SiteBillingInsurancePendingInsuranceInfoBanner extends Component {
    title = (pendingInsuranceInfoCount1)=>{
        if (pendingInsuranceInfoCount1 === 1) {
            return '1 new insurance info is pending approval';
        } else {
            return `${pendingInsuranceInfoCount1} new insurance infos are pending approval`;
        }
    };
    static{
        template(`
    <div class={{styles.component}}>
      <SharedBannerMessage
        @type="info"
        @container="self"
        @classNames="icon-inline"
        @isPermanent={{true}}
        @title={{this.title @pendingInsuranceInfoCount}}
        data-test-pending-insurance-info-banner
      >
        {{svgJar "information"}}
        <p>
          You will be notified when your insurance info has been accepted and applied
        </p>
      </SharedBannerMessage>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
